import { render } from "@/components/pages/immobilizer/Immobilizer.html?vue&type=template&id=156b239f&external"
import script from "@/components/pages/immobilizer/Immobilizer.js?vue&type=script&lang=js&external"
export * from "@/components/pages/immobilizer/Immobilizer.js?vue&type=script&lang=js&external"

import "@/components/pages/immobilizer/Immobilizer.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__